// extracted by mini-css-extract-plugin
export default {"grid":"TemplateGrid_grid__0L8gc"};